export type MonetizationInstrumentType =
  | 'loan'
  | 'check'
  | 'promissory_note'
  | 'commercial_endorsement';

const MONETIZATION_INSTRUMENT_LABELS: Record<MonetizationInstrumentType, string> = {
  loan: 'Préstamo',
  check: 'Cheque',
  promissory_note: 'Pagaré',
  commercial_endorsement: 'Aval Comercial',
};

export const getMonetizationInstrumentLabel = (
  type: MonetizationInstrumentType,
): string => MONETIZATION_INSTRUMENT_LABELS[type] ?? type;
